import { gray0, gray1 } from 'emerald-ui/dist/globals/colors';
import { LabeledValue_Label, LabeledValue_Root } from 'emerald-ui/dist/LabeledValue';
import styled from 'styled-components';
import { theme } from '../../styles/theme';

export const DataHeader_Root = styled.div`
    display: flex;
    width: 100%;
    background: ${gray1};

    ${LabeledValue_Label} {
        white-space: nowrap;
    }

    ${theme.breakpoints.only('xs')} {
        flex-direction: column;
    }
`;

export const DataHeader_Left = styled.div`
    display: flex;
    align-items: center;
    border-right: 1px solid ${gray0};
    font-size: 2.125rem; /* 34px */
    padding-right: 1em;

    ${LabeledValue_Root} {
        padding: 0;
        font-size: inherit;
        white-space: nowrap;
    }

    ${theme.breakpoints.only('xs')} {
        padding: .75em 0;
        border-right: 0;
    }
`;

export const DataHeader_Right = styled.div`
    flex-grow: 1;
`;
